<template>
	<div class="drawer">
		<el-drawer
		v-if="msg.careId"
		size="80%"
		title="11"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<div style="padding-bottom:40px;">
				<el-row style="padding:40px 20px 0;float: none;font-size: 14px;">
					<el-col :span="6">
						<span class="label">顾客：</span>
						<span class="value">{{msg.memberName}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">手机号：</span>
						<span class="value">{{msg.memberMobile}}</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 14px;">
					<el-col :span="6">
						<span class="label">经办人：</span>
						<span class="value">
							<span v-for="item in msg.serviceMan" :key="item">{{item+' '}}</span>
						</span>
					</el-col>
					<el-col :span="6">
						<span class="label">备注：</span>
						<span class="value">{{msg.remark}}</span>
					</el-col>
				</el-row>
			</div>
			<div style="border-top:1px solid #eee;padding:30px 0;" v-for="(item,index) in msg.pets" :key="index">
				<el-row style="padding:0px 20px 0;float: none;font-size: 14px;">
					<el-col :span="6">
						<span class="label">宠物昵称：</span>
						<span class="value">{{item.petName}}</span>
					</el-col>
					<!-- <el-col :span="6">
						<span class="label">笼子：</span>
						<span class="value">
							<span v-for="(cagesItem,cagesIndex) in item.cages" :key="cagesIndex">{{cagesItem.name+' '}}</span>
						</span>
					</el-col> -->
					<el-col :span="12">
						<span class="label">状态：</span>
						<span class="value">
							{{item.status===1?'寄养中':'已寄养结束'}}
						</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 14px;">
					<el-col :span="6">
						<span class="label">种类：</span>
						<span class="value">{{item.className}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">品种：</span>
						<span class="value">{{item.typeName}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">性别：</span>
						<span class="value">{{item.sex}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">体重：</span>
						<span class="value">{{item.weight}} kg</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 14px;">
					<el-col :span="6">
						<span class="label">开始时间：</span>
						<span class="value">{{$public.FTime(item.beginDate,'YYYY-MM-DD HH:mm:ss')}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">结束时间：</span>
						<span class="value">{{$public.FTime(item.endDate,'YYYY-MM-DD HH:mm:ss')}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">活动：</span>
						<span class="value">{{item.activityName}}</span>
					</el-col>
					<el-col :span="6">
						<span class="label">已产生寄养费：</span>
						<span class="value">{{item.totalMoney}} 元</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 14px;">
					<el-col :span="12">
						<span class="label">备注：</span>
						<span class="value">{{item.remark}}</span>
					</el-col>
				</el-row>
				<div style="padding:40px 40px 0;float: none;font-size: 14px;">
					<el-table :data="item.goodsList" height="100%" style="width: 100%">
						<el-table-column label="单号" width="175">
							<template slot-scope="scope">
								<span>{{scope.row.orderNum}}</span>
							</template>
						</el-table-column>
						<el-table-column label="名称" width="150">
							<template slot-scope="scope">
								{{scope.row.goodsName}}
							</template>
						</el-table-column>
						<el-table-column label="规格">
							<template slot-scope="scope">
								{{scope.row.skuValue}}
							</template>
						</el-table-column>
						<el-table-column label="日期">
							<template slot-scope="scope">
								{{$public.FTime(scope.row.fosterCareDate,'YYYY-MM-DD')}}
							</template>
						</el-table-column>
						<el-table-column label="单价" width="70">
							<template slot-scope="scope">
								{{scope.row.price}}
							</template>
						</el-table-column>
						<el-table-column label="数量" width="135">
							<template slot-scope="scope">
								{{scope.row.num}}
							</template>
						</el-table-column>
						<el-table-column label="单位" width="140">
							<template slot-scope="scope">
								{{scope.row.unit}}
							</template>
						</el-table-column>
						<el-table-column label="总价" width="135">
							<template slot-scope="scope">
								{{scope.row.totalMoney}}
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				msg:{},
				allMoney:0,
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
		},
		props:{
			curItem:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			this.$nextTick(()=>{this.drawerStatus=true})
			this.getGoodsMsg(this.curItem.recordId)
		},
		methods: {
			handleClose(){
				this.$emit('close')
			},
			// 获取商品信息
			getGoodsMsg(recordId) {
				let loading = this.$loading()
				this.$http.get('/api/FosterCare/Detail/Pet', {
					recordId: recordId
				}).then(res=>{
					loading.close();
					if(res.code===0){
						this.msg = res.data;
						this.allMoney = 0;
						for(let i=0;i<this.msg.pets.length;i++){
							let item = this.msg.pets[i];
							this.allMoney = this.$public.jia(this.allMoney,item.totalMoney)
						}
					}
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.label{
				display: inline-block;width:150px;text-align: right;
			}
		}
		
	}
	
</style>
